<template>
  <div class="documents-group">
    <div class="documents-group__header">
      <div class="documents-group__data">
        <toggle-button v-model="isOpen" class="documents-group__toggler" :disabled="noAnalysesInGroup" />
        <div class="documents-group__info">
          <div class="documents-group__name">
            {{ group.name }}
          </div>
          <div v-if="group.description" class="documents-group__description">
            {{ group.description }}
          </div>
        </div>
      </div>

      <div class="documents-group__actions">
        <c-button-2
          :id="`medical-analyse-edit-button-${group.id}`"
          class="documents-group__edit"
          size="iconic"
          icon="edit"
          @click="onEdit"
        />

        <span
          v-if="group['analyses'].length > 0"
          :id="`document-group-remove-${group.id}`"
          class="documents-group__remove"
        >
          <c-button-2
            :id="`medical-analyse-remove-button-${group.id}`"
            size="iconic"
            :icon="{ icon: 'trash', color: 'secondary' }"
            disabled
          />
        </span>

        <c-button-2
          v-else
          :id="`medical-analyse-remove-button-${group.id}`"
          class="documents-group__remove"
          size="iconic"
          :icon="{ icon: 'trash', color: 'secondary' }"
          @click="onRemove"
        />

        <c-button-2
          :id="`medical-analyse-sort-button-${group.id}`"
          class="documents-group__move"
          size="iconic"
          icon="arrows-constructor"
        />

        <b-popover
          placement="top"
          triggers="hover blur"
          container="app"
          boundary="window"
          :target="`document-group-remove-${group.id}`"
        >
          <error-feedback
            class="m-0 empty-category-tooltip"
            text="В данный момент удаление невозможно, так как тип анализа содержит данные. Сначала перенесите все данные из типа."
          />
        </b-popover>
        <b-popover placement="top" triggers="hover" :target="`medical-analyse-edit-button-${group.id}`">
          Редактировать
        </b-popover>
        <b-popover placement="top" triggers="hover" :target="`medical-analyse-remove-button-${group.id}`">
          Удалить
        </b-popover>
        <b-popover placement="top" triggers="hover" :target="`medical-analyse-sort-button-${group.id}`">
          Переместить
        </b-popover>
      </div>
    </div>

    <slide-up-down :active="isOpen || noAnalysesInGroup" :duration="400" class="documents-group__items">
      <draggable
        class="item-sub item-container"
        group="type"
        :list="group.analyses"
        :move="onMove"
        :force-fallback="true"
        ghost-class="sortable__ghost"
        @change="onSort"
        @moving="onMovingElement"
      >
        <div v-for="analyse in group['analyses']" :key="analyse.id">
          <medical-analyse-group-item
            v-show="isAnalyseVisible(analyse)"
            :analyse="analyse"
            @remove="onAnalyseRemove(analyse)"
          />
        </div>
      </draggable>
    </slide-up-down>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SlideUpDown from "vue-slide-up-down";
import Button2 from "@/components/controls2/Button";
import ToggleButton from "@/components/controls/toggle-button";
import ErrorFeedback from "@/components/error-feedback";

import MedicalAnalyseGroupItem from "./medical-analyses-group-item";

export default {
  name: "medical-analyses-group",
  components: {
    draggable,
    "slide-up-down": SlideUpDown,
    "c-button-2": Button2,
    "toggle-button": ToggleButton,
    ErrorFeedback,
    MedicalAnalyseGroupItem,
  },
  props: {
    group: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    nameMatched() {
      return this.group.name.toLowerCase().includes(this.query);
    },
    descriptionMatched() {
      return this.group.description.toLowerCase().includes(this.query);
    },
    noAnalysesInGroup() {
      return this.group.analyses.length === 0;
    },
  },
  watch: {
    query(v) {
      if (v) this.isOpen = true;
    },
    noAnalysesInGroup(v) {
      if (v) {
        this.isOpen = false;
      }
    },
  },
  methods: {
    onMove(event) {
      event.relatedContext.component.$emit("moving");
    },
    onSort(event) {
      if (event.added) {
        this.$emit("add-analyse", {
          typeId: this.group.id,
          analyse: event.added.element,
        });
      }
      this.$emit("resort", event);
    },
    onMovingElement() {
      this.isOpen = true;
    },
    onRemove() {
      this.$emit("remove-group", this.group);
    },
    onEdit() {
      this.$emit("edit-group", { group: this.group });
    },
    onAnalyseRemove(analyse) {
      this.$emit("remove-analyse", { group: this.group, analyse });
    },
    isAnalyseVisible(analyse) {
      if (!this.query) return true;
      if (this.nameMatched || this.descriptionMatched) return true;

      return analyse.name.toLowerCase().includes(this.query);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 480px) {
  .documents-group__header {
    border-left: none;
    border-right: none;
  }
}
.documents-group {
  &__header {
    margin-top: -1px;
  }
  &__name {
    min-width: fit-content;
    margin-bottom: 3px;
  }
  &__info {
    @media (min-width: 640px) {
      display: flex;
      align-items: center;
    }
    word-break: break-word;
    flex-wrap: wrap;
    font-weight: 500;
    font-size: 15px;
    line-height: 108%;
    color: #000000;
    max-width: calc(100% - 40px);
    overflow-wrap: break-word;
  }
  &__description {
    margin-top: 2px;
    font-weight: 400;
    padding-right: 10px;
    @media (min-width: 640px) {
      margin-top: 0;
    }
  }
}
.empty-category-tooltip {
  max-width: 200px;
}
</style>
